/**
 * The MLB has not published its official calendar yet, so every
 * customer-facing event date/time renders a hardcoded TBD while this
 * flag is on. Gate rendering only; `SaleEvent.date` keeps its real
 * value (rainout logic and analytics depend on it).
 * Rollback: set this flag to false, or revert the TBD commit. The
 * original markup stays under the `@else` branch of every gate.
 */
export const SHOW_EVENT_DATE_AS_TBD = true;

export const EVENT_DATE_TBD_TEXT = 'TBD';
